/** Error boundary de rota (CLAUDE.md §4). */
import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Sem PII no console: o aluno não é identificado aqui (RN-13).
    console.error('reader_error', error.message, info.componentStack)
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div role="alert" className="error-boundary">
            <h1>Algo deu errado</h1>
            <p>Recarregue a página. Se continuar, avise seu professor.</p>
            <button type="button" onClick={() => window.location.reload()}>
              Recarregar
            </button>
          </div>
        )
      )
    }
    return this.props.children
  }
}
